"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_SRC = "/image/new-version/casting/Vacuum-Casting/when-to-choose-vacuum-casting.webp";

export default function WhenToChooseVacuumCasting() {
	const t = useTranslations("new-vacuum-casting");

	return (
		<section className="bg-[#ffffff] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid grid-cols-1 items-center gap-8 md:gap-10 lg:grid-cols-2 lg:gap-16">
					<div className="order-2 lg:order-1">
						<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
							{t("whenToChooseTitle")}
						</h2>
						<p className="text-sm leading-relaxed text-black md:text-base">{t("whenToChooseDesc")}</p>
					</div>
					<div className="order-1 lg:order-2">
						<div className="relative aspect-[16/9] w-full overflow-hidden">
							<Image
								src={IMAGE_SRC}
								alt={t("whenToChooseImageAlt")}
								fill
								className="object-cover"
								sizes="(max-width: 1024px) 100vw, 50vw"
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
